import React from 'react';
import { ContactUs } from '../../components/contactUs';

const ContactUsPage = () => {
  return (
    <>
      <ContactUs />
    </>
  );
};

export default ContactUsPage;
